import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { deleteFolder } from '~/generated/sdk.gen';
import { extractData } from '~/utils/query-utils';

type DeleteFolderParams = {
  folderId: string;
  recursive?: boolean;
};

export const useDeleteFolder = (
  options: UseMutationOptions<
    unknown,
    unknown,
    DeleteFolderParams,
    unknown
  > = {}
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ folderId, recursive = true }: DeleteFolderParams) => {
      return extractData(
        deleteFolder({
          path: { folderId },
          query: {
            recursive,
          },
        })
      );
    },
    ...options,
    onSuccess(data, variables, mutationResult, context) {
      queryClient.invalidateQueries({ queryKey: ['document-share'] });
      options.onSuccess?.(data, variables, mutationResult, context);
    },
  });
};
